/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const candidacyProfileDataSchema = z.object({
	name: z.string().nullable(),
	email: z.string().nullable(),
	phone: z.string().nullable(),
	canBeContacted: z.boolean(),
	cv: z.object({ id: z.string(), fileName: z.string(), sizeInBytes: z.number(), uploadedAt: z.iso.datetime() })
		.nullable(),
	workHistory: z.array(
		z.object({ id: z.string(), contents: z.string(), createdAt: z.iso.datetime(), updatedAt: z.iso.datetime() }),
	),
	education: z.array(
		z.object({ id: z.string(), contents: z.string(), createdAt: z.iso.datetime(), updatedAt: z.iso.datetime() }),
	),
	licenses: z.array(
		z.object({ id: z.string(), contents: z.string(), createdAt: z.iso.datetime(), updatedAt: z.iso.datetime() }),
	),
})

export type CandidacyProfileDataSchema = z.infer<typeof candidacyProfileDataSchema>
